import { TsFixMeType } from '../types';

export enum AuthenticationProviderActionTypes {
  START = 'start',
  LOGIN = 'login',
  SOCIAL_LOGIN = 'socialLogin',
  LOGOUT = 'logout',
  ERROR = 'error',
  RESET = 'reset',
  PREFERENCES = 'preferences',
  USER_DATA = 'userData',
  RELOAD = 'reload',
}

export interface AuthState {
  username: string | null;
  token: string | null;
  refresh_token: string | null;
  userHasBeenSwitched: boolean;
  /**
   * @deprecated use hasError instead
   */
  error: boolean;
  /**
   * @deprecated use isPending instead
   */
  pending: boolean;
  /**
   * @deprecated use isInitializing instead
   */
  initializing: boolean;
  hasError?: boolean;
  isPending?: boolean;
  isInitializing?: boolean;
}

export interface AuthReducerAction {
  type: AuthenticationProviderActionTypes;
  payload?: TsFixMeType;
}
